import {defineStore} from 'pinia';
import type {RelatedCustomer} from 'dummen-shared';
import {type Ref, ref} from 'vue';

export const useRelatedCustomersStore = defineStore('relatedCustomers', () => {

	const relatedCustomers: Ref<RelatedCustomer[]> = ref([]);

	const setRelatedCustomers = (relatedCustomerData: RelatedCustomer[]) => {
		relatedCustomers.value = relatedCustomerData;
	};

	return {
		relatedCustomers,
		setRelatedCustomers
	};
});
